/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Category } from '../../models/category';

export interface DocumentGetcategorylistbypatient$Params {
  patientId?: string | null;
  emrpracticeId?: string | null;
}

export function documentGetcategorylistbypatient(http: HttpClient, rootUrl: string, params?: DocumentGetcategorylistbypatient$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Category>>> {
  const rb = new RequestBuilder(rootUrl, documentGetcategorylistbypatient.PATH, 'get');
  if (params) {
    rb.query('patientId', params.patientId, {});
    rb.query('emrpracticeId', params.emrpracticeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Category>>;
    })
  );
}

documentGetcategorylistbypatient.PATH = '/document/getcategorylistbypatient';
